<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card common-bg" shadow="never">
      <div slot="header" class="clearfix">
        <h3>WPay</h3>
      </div>
      <div style="padding: 24px 40px;">
        <p v-if="linked" class="linked-msg">您已绑定 WPay，无需重复绑定。</p>
        <div v-else>
          <el-button type="warning" :loading="linking" @click="startLink" style="background-color: #C03D33;border:#C03D33">绑定 WPay</el-button>
        </div>
        <p v-if="errorText" class="error-msg">{{ errorText }}</p>
      </div>
      <el-card class="box-card">
        <div v-html="description" style="padding:20px 20px 20px 40px"></div>
      </el-card>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "wpay",
  data() {
    return {
      linked: false,
      description: "",
      linking: false,
      errorText: ""
    };
  },
  mounted: function() {
    this.finishReturn();
  },
  methods: {
    returnAuth() {
      const search = new URLSearchParams(window.location.search);
      let code = search.get("code") || "";
      let state = search.get("state") || "";
      let error = search.get("error") || "";
      const hash = window.location.hash || "";
      const hashQuery = hash.indexOf("?") >= 0 ? hash.slice(hash.indexOf("?") + 1) : "";
      if (hashQuery) {
        const hashParams = new URLSearchParams(hashQuery);
        code = code || hashParams.get("code") || "";
        state = state || hashParams.get("state") || "";
        error = error || hashParams.get("error") || "";
      }
      if (this.$route.query) {
        code = code || this.$route.query.code || "";
        state = state || this.$route.query.state || "";
        error = error || this.$route.query.error || this.$route.query.wpay_error || "";
      }
      return { code: code, state: state, error: error };
    },
    clearReturnQuery() {
      const params = new URLSearchParams(window.location.search);
      params.delete("code");
      params.delete("state");
      params.delete("error");
      const search = params.toString();
      const hash = (window.location.hash || "").split("?")[0];
      window.history.replaceState({}, "", window.location.pathname + (search ? "?" + search : "") + hash);
    },
    finishReturn() {
      let that = this;
      const auth = that.returnAuth();
      if (!auth.state || (!auth.code && !auth.error)) {
        that.loadInfo();
        return;
      }
      that.linking = true;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "wpay_link_return",
            token: sessionStorage.getItem("token"),
            code: auth.code,
            state: auth.state,
            error: auth.error
          }
        })
        .then(function(ret) {
          that.linking = false;
          that.clearReturnQuery();
          if (ret.data.code != 1) {
            that.errorText = ret.data.msg || "绑定失败";
          }
          that.loadInfo();
        })
        .catch(function() {
          that.linking = false;
          that.clearReturnQuery();
          that.loadInfo();
        });
    },
    loadInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "wpay_info",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(ret) {
          if (ret.data.code == 1) {
            that.linked = ret.data.data.linked == 1;
            that.description = ret.data.data.description || "";
          } else {
            that.$message.error(ret.data.msg);
          }
        });
    },
    startLink() {
      let that = this;
      that.linking = true;
      that.errorText = "";
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "wpay_link_start",
            token: sessionStorage.getItem("token"),
            return_url: window.location.href.split("?")[0]
          }
        })
        .then(function(ret) {
          that.linking = false;
          if (ret.data.code == 1 && ret.data.data.authorize_url) {
            window.location.href = ret.data.data.authorize_url;
          } else {
            that.$message.error(ret.data.msg || "绑定失败");
          }
        })
        .catch(function() {
          that.linking = false;
        });
    }
  }
};
</script>
<style scoped>
.linked-msg {
  color: #142485;
  font-size: 16px;
}
.error-msg {
  color: #D02E27;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/wpay.vue